import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerItemKeys,
} from '@core/react-query/features/registers/registers/register/items/item'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemsKeys } from '@core/react-query/features/registers/registers/register/items'

export const useMoveOrTransferItemsToDiagram = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['moveOrTransferItemsToDiagram']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerItemKeys.moveOrTransferItemsToDiagram,
    ...options,
    onSuccess: () =>
      queryClient.invalidateQueries(registerItemsKeys.itemsByRegisterId._def),
  })
}
